import { render, staticRenderFns } from "@/client/budget/views/acceptance/choose-delegation/choose-delegation.pug?vue&type=template&id=05c313f0&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/client/budget/views/acceptance/choose-delegation/choose-delegation.scss?vue&type=style&index=0&id=05c313f0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c313f0",
  null
  
)

export default component.exports